export enum BlacklistedEmailDomains {
    Hotmail = 'hotmail.com',
    Gmail = 'gmail.com',
    AOL = 'aol.com',
    Yahoo = 'yahoo.com',
    ICloud = 'icloud.com',
    Comcast = 'comcast.com',
    Outlook = 'outlook.com',
    Zoho = 'zoho.com',
    MSN = 'msn.com',
    HotmailCoUk = 'hotmail.co.uk',
    SBCGlobal = 'sbcglobal.net'
}
